<div class="breadcrumb-container">
    <div class="breadcrumb">
<span *ngFor="let cat of category; let isLast = last" [ngClass]="isLast && !title ? 'title' : 'breadcrumb-element'"
      (click)="isLast && !title ? '' : openCategory(cat.id)">{{cat.title}}</span>
        <span *ngIf="title" class="title">{{title}}</span>
    </div>
</div>
